import React, { useContext } from 'react';

import { Styled } from './Video.styles';
import { context } from './context';

import { emptyArray } from 'utils/array';

export const CamerasList: React.FC = () => {
  const { vehicle, selectedCam, onSelectCam } = useContext(context);

  const cameras = emptyArray(vehicle?.cameraCount || 0);

  return (
    <Styled.CamerasList>
      {cameras.map((_, i) => (
        <Styled.CameraItem
          onClick={() => onSelectCam(i + 1)}
          tabIndex={i + 1}
          key={i}
        >
          {i + 1}
        </Styled.CameraItem>
      ))}
    </Styled.CamerasList>
  );
};
